import io from 'socket.io-client';

let socket = null;
class HubSocketHelper{
  constructor(room) {
    if (socket) {
      // return socket;
    }else {
      socket = io('https://io.joonaakhub.com/');
      if (socket && room) socket.emit('roomJoin', {roomId: room});
      // return socket;
    }
  }
  initiateSocket(room) {
    if (socket && room) socket.emit('roomJoin', {roomId: "HUB2B"});
  }

  listenEvent(eventName, cb) {
    socket.on(eventName, cb);
  }
}

// let socket;
// const initiateSocket = (room) => {
//   socket = io('https://io.joonaakhub.com/');
//   console.log(`Connecting socket...`);
//   if (socket && room) socket.emit('roomJoin', {roomId: "HUB2B"});
// }

// const listenEvent = (eventName, cb) => {
//   socket.on(eventName, cb);
// }


export {
  HubSocketHelper
  // initiateSocket,
  // listenEvent,
}

// class DriverLiveLocationSocket {
//   wsInstance = null;
//   // wsInstance = null;
//   // constructor() {
//   //   if (this.wsInstance) {
//   //     return this.wsInstance;
//   //   }
//   // }

//   async init() {
//     // return new Promise(async (resolve) => {
//     //   this.wsInstance = openSocket('https://io.joonaakhub.com/');
//     //   resolve("success");
//     // });
//   }
//   // async init() {
//   //   console.log(">init socket")
//   //   const socket = openSocket('http://localhost:8000');
//   //   return new Promise(async (resolve) => {

//   //     this.wsInstance = new io("https://io.joonaakhub.com/", {
//   //       transports: ["websocket"],
//   //       enablesXDR: true,
//   //       autoConnect: true,
//   //     });

//   //     // console.log(">init socket 1", this.wsInstance)

//   //     // this.wsInstance.on("connection", (socket) => {
//   //     //   console.log(socket.handshake.query); // prints { x: "42", EIO: "4", transport: "polling" }
//   //     // });


//   //     // this.wsInstance.on("connect", () => {
//   //     //   console.log(">init socket 2")
//   //     //   console.log("connected websocket main component");
//   //       //   let msg = {
//   //       //     roomId: "4bdf2b98-09da-40db-9096-532f6499efd5",
//   //       //     data: null,
//   //       //     extra_event: "STARTING",
//   //       //   };
//   //       //   this.wsInstance.emit("roomUpdateAny", msg);
//   //       // let data = {
//   //       //   roomId: "HUB2B",
//   //       // };

//   //       //this.wsInstance.emit("roomJoin", data);
//   //       // this.subscribe("REQUESTED", (data) => {
//   //       //   console.log("this is data ===>", data);
//   //       // });

//   //       resolve("success");
//   //     // });

//   //     // console.log(">init socket 3")
//   //     // this.wsInstance.on("disconnect", function () {
//   //       // console.log("socket disconnect");
//   //     // });
//   //   });
//   // }

//   // emit(roomId, data, eventName) {
//   //   let msg = {
//   //     roomId,
//   //     data,
//   //     extra_event: eventName,
//   //   };

//   //   this.wsInstance.emit("roomUpdateAny", msg);
//   // }

//   // subscribe(eventName, cb) {
//   //   // console.log("event name:", eventName);
//   //   // console.log("cb==>", cb);
//   //   if (this.wsInstance) {
//   //     this.wsInstance.on(eventName, cb);
//   //   }
//   // }
// }


// // export default DriverLiveLocationSocket;
